import SenderPersonaForm from "../_components/SenderPersonaForm";
import { useParams } from "react-router-dom";
import { PageAccessGuard } from "@/components/auth/PageAccessGuard";

const SenderPersonaFormPage: React.FC = () => {
  return (
    <PageAccessGuard authority="ADMIN_SENDER_PERSONA_UPDATE">
      <SenderPersonaFormContent />
    </PageAccessGuard>
  );
};

const SenderPersonaFormContent: React.FC = () => {
  const { id } = useParams<{ id: string }>();
  
  // If id exists, we're in edit mode, otherwise create mode
  const mode = id ? "edit" : "create";
  
  return <SenderPersonaForm mode={mode} personaId={id} />;
};

export default SenderPersonaFormPage;
